export default "__VITE_ASSET__e5TCUl7___"